// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ZJoN{background:#fff;border-radius:4px;cursor:pointer;display:-ms-flexbox;display:flex;height:18px;position:relative;-webkit-transition:all .3s ease;transition:all .3s ease;width:32px;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;border:1px solid #30a8ff;justify-content:flex-start;padding:3px}html[dir=ltr] ._1ZJoN{margin-right:8px}html[dir=rtl] ._1ZJoN{margin-left:8px}._18QK5{background:#30a8ff}html[dir=ltr] ._18QK5{padding-left:16px}html[dir=rtl] ._18QK5{padding-right:16px}._2d1mA{background:#f5f9ff;border:1px solid #e0e8f2}._1Wm2h{background:#30a8ff;border-radius:2px;height:12px;width:12px}._118HT{background:#fff}._3ZP_3{background:#e0e8f2}._1u6Di{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.EWEY4{color:#0a385a;font-size:14px;font-size:1.4rem}", ""]);
// Exports
exports.locals = {
	"switch": "_1ZJoN",
	"switch--on": "_18QK5",
	"switch--disabled": "_2d1mA",
	"switch__cursor": "_1Wm2h",
	"switch__cursor--on": "_118HT",
	"switch__cursor--disabled": "_3ZP_3",
	"switch__container": "_1u6Di",
	"switch__label": "EWEY4"
};
module.exports = exports;
